<template>
	<b-row>
		<b-col>
			<h4 class="mt-3">Armor</h4>
			<b-table-simple responsive small bordered striped table-class="mb-0">
				<b-thead>
					<b-tr>
						<b-th colspan="6"><span class="lead">{{Character.Equipment.Armor[Character.Current.Armor].Name}}</span></b-th>
					</b-tr>
					<b-tr>
						<b-th></b-th>
						<b-th class="text-center">=</b-th>
						<b-th class="text-center">Base</b-th>
						<b-th class="text-center">+ Dex</b-th>
						<b-th class="text-center">+ Armor</b-th>
						<b-th class="text-center">+ Misc</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr>
						<b-th scope="row">EAC</b-th>
						<b-td class="text-center font-weight-bold">{{totalArmor(Character.Equipment.Armor[Character.Current.Armor].EAC, Character.Equipment.Shield.BonusWielded, Character.Equipment.Armor[Character.Current.Armor].Misc.EAC)}}</b-td>
						<b-td class="text-center">10</b-td>
						<b-td class="text-center">{{dexToAC}}</b-td>
						<b-td class="text-center">{{Character.Equipment.Armor[Character.Current.Armor].EAC}}</b-td>
						<b-td class="text-center">{{Character.Equipment.Armor[Character.Current.Armor].Misc.EAC}}</b-td>
					</b-tr>
					<b-tr>
						<b-th scope="row">KAC</b-th>
						<b-td class="text-center font-weight-bold">{{totalArmor(Character.Equipment.Armor[Character.Current.Armor].KAC, Character.Equipment.Shield.BonusWielded, Character.Equipment.Armor[Character.Current.Armor].Misc.KAC)}}</b-td>
						<b-td class="text-center">10</b-td>
						<b-td class="text-center">{{dexToAC}}</b-td>
						<b-td class="text-center">{{Character.Equipment.Armor[Character.Current.Armor].KAC}}</b-td>
						<b-td class="text-center">{{Character.Equipment.Armor[Character.Current.Armor].Misc.KAC}}</b-td>
					</b-tr>
					<b-tr>
						<b-th scope="row">CM</b-th>
						<b-td class="text-center font-weight-bold">{{totalArmor(Character.Equipment.Armor[Character.Current.Armor].KAC+8, Character.Equipment.Shield.BonusWielded, Character.Equipment.Armor[Character.Current.Armor].Misc.CM)}}</b-td>
						<b-td class="text-center">8</b-td>
						<b-td class="text-center" colspan="2">+ {{totalArmor(Character.Equipment.Armor[Character.Current.Armor].KAC, Character.Equipment.Shield.BonusWielded, Character.Equipment.Armor[Character.Current.Armor].Misc.KAC)}} <strong>KAC</strong></b-td>
						<b-td class="text-center">{{Character.Equipment.Armor[Character.Current.Armor].Misc.CM}}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
			<b-table-simple responsive small bordered striped class="mb-2" table-class="mb-0" v-if="hasArmorUpgrades">
				<b-thead>
					<b-tr>
						<b-th colspan="3"><span class="lead text-muted">Armor Upgrades</span></b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr v-for="(upgrade, upgradeID) in usedArmorUpgradeSlots" :key="'armorUpgrade-'+upgradeID">
						<b-td v-bind:colspan="(upgrade.Capacity != '')?'1':'3'">{{upgrade.Name}}</b-td>
						<b-td v-if="upgrade.Capacity != ''" class="table-cell-blank"></b-td>
						<b-td v-if="upgrade.Capacity != ''" class="text-right">{{upgrade.Capacity}}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-col>
	</b-row>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters([
			'usedArmorUpgradeSlots',
		]),
		...mapGetters('character/abilityScores',[
			'abilityMods',
		]),
		...mapGetters('character/equipment',[
			'dexToAC',
			'totalArmor',
			'hasArmorUpgrades',
		])
	},
}
</script>

<style scoped>

</style>